import { Col, Row } from 'antd'
import { Suspense, useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { InfoTooltip } from '../../components/display/InfoTooltip'
import { WizardWrapper } from '../../components/display/WizardWrapper'
import { Navigation } from '../../components/Navigation'
import { SpinnerFullHeight } from '../../components/spinner/SpinnerFullHeight'
import { COLOR_PRIMARY, SUB_PAGES } from '../../constants'
import { useProjectById } from '../../hooks/useProjectById'
import { useProjects } from '../../hooks/useProjects'
import { dataStore } from '../../store/dataStore'
import { useSiteCustomIds } from '../../store/useSiteCustomIds'
import { AssignmentFilterEnum } from '../../Types'
import { ProjectType } from '../project/ProjectPage'
import {
  ApplyFiltersButton,
  AssignmentFilter,
  DatesPicker,
  ExcludeForecastStates,
  ExtraProjectsFilter,
  FilterAges,
  SiteFilter,
  ToggleDbResponders,
} from './Filters'
import { GeneralStatsPage } from './general/GeneralPage'
import VisitsPage from './visits/Visitspage'

const tabs = [
  {
    name: 'General',
    page: <GeneralStatsPage />,
  },
  /*  {
    name: 'Financials',
    page: <FinancialsStatsPage />,
  }, */
  {
    name: 'Visits',
    page: <VisitsPage />,
  },
] as const

export const StatsPage = () => {
  const { projectId } = useParams() as { projectId: string }
  const { data: projectData } = useProjectById(projectId)
  const project: ProjectType = projectData.project

  const { data: allProjects } = useProjects()

  const otherProjects = allProjects.filter((p) => !(p._id === projectId))

  const [pageIndex, setPageIndex] = useState(0)

  const customIds = useSiteCustomIds()
  let [, setSearchParams] = useSearchParams()

  const [initializedProjectId, setInitializedProjectId] = useState<string>('')

  const initialized = initializedProjectId === projectId

  // initially check all sanos sites.
  useEffect(() => {
    if (!initialized) {
      const store = dataStore.getState()

      const initialSiteIds = customIds.uniqSanosCustomIds

      console.log('init customIds:', { customIds })
      store.setStatsSelectedSites(initialSiteIds, false)
      store.setHasUnappliedFilters(false)
      store.setStatsIncludeDbResponders(true)
      store.setStatsExtraProjects(undefined)
      store.setStatsSelectedDateRange(undefined)
      store.setStatsForecastExcludeStates(undefined)
      store.setStatsAges(undefined)
      store.setStatsAssignment(AssignmentFilterEnum.All)
      setSearchParams({ siteIds: initialSiteIds.join(';') })

      setInitializedProjectId(projectId)
    }
  }, [projectId, initialized, customIds, setSearchParams])

  if (!initialized) {
    return null
  }

  return (
    <>
      <Navigation pages={SUB_PAGES} projectId={projectId}></Navigation>
      <div className="container-fluid bg-white">
        <div className="container">
          <Row className="py-4" gutter={48}>
            <Col span={8}>
              <h3 className="fw-bold">{project.title}</h3>
              <p className="fw-bold opacity-75">{project.projectRef}</p>
            </Col>
            <Col span={6}>
              <div>
                <p className="text-muted small">
                  Forecast excluding:{' '}
                  <InfoTooltip
                    content={
                      <p>
                        When calculating the forecast, don't include responders currently{' '}
                        <span className="text-muted">awaiting</span> in these states.
                      </p>
                    }
                  />
                </p>
                <ExcludeForecastStates />
              </div>
              <div className="mt-4">
                <DatesPicker style={{ width: '100%' }} />
              </div>

              <div className="mt-4">
                <ToggleDbResponders />
              </div>
              <AssignmentFilter />
            </Col>
            <Col span={8}>
              <div>
                <p className="text-muted small">Extra projects:</p>
                <ExtraProjectsFilter otherProjects={otherProjects} />
              </div>

              <div className="mt-4">
                <SiteFilter />
              </div>
              <div className="mt-4">
                <FilterAges />
              </div>
            </Col>
            <Col span={2}>
              <div className="d-flex justify-content-end">
                <Suspense fallback={<SpinnerFullHeight />}>
                  <ApplyFiltersButton />
                </Suspense>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Suspense fallback={<SpinnerFullHeight />}>
        <div className="container mt-2 mb-4">
          <div className="row" style={{}}>
            <div className="col-12">
              <div className="d-flex justify-content-around" style={{ borderBottom: `1px solid #B5C7CF` }}>
                {tabs.map((tab, index) => {
                  return (
                    <div
                      className="use-pointer no-select text-primary pt-3"
                      style={{
                        borderBottom: pageIndex === index ? `3px solid ${COLOR_PRIMARY}` : `0px solid ${COLOR_PRIMARY}`,
                        width: '50%',
                      }}
                      key={index}
                      onClick={() => {
                        setPageIndex(index)
                      }}
                    >
                      <div className="px-4 text-center">
                        <p
                          style={{
                            color: pageIndex === index ? '#08455f' : '#7b7b7b',
                            fontSize: '.8rem',
                            marginBottom: '1em',
                            fontWeight: 'bold',
                          }}
                        >
                          {tab.name.toUpperCase()}
                        </p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
        <WizardWrapper pageIndex={pageIndex}>
          {tabs.map((tab, index) => {
            return <div key={index}>{tab.page}</div>
          })}
        </WizardWrapper>
      </Suspense>
    </>
  )
}
